
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              Wonder Arch Panel
            </h3>
            <p className="text-gray-300 mb-4 max-w-md">
              Leading manufacturer of hardened aircraft shelter arch panels, providing superior protection for military and civilian aviation facilities worldwide.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Products</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Arch Panel Systems</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Hardened Shelters</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Custom Solutions</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Maintenance Kits</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Contact</h4>
            <ul className="space-y-2 text-gray-300">
              <li className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                <a href="tel:+82-2-2247-1900" className="hover:text-white transition-colors cursor-pointer">
                  +82-2-2247-1900
                </a>
              </li>
              <li className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                <a href="mailto:hanbum@hanbum.co.kr" className="hover:text-white transition-colors cursor-pointer">
                  hanbum@hanbum.co.kr
                </a>
              </li>
              <li className="flex items-center">
                <i className="ri-map-pin-line mr-2"></i>
                16-4, Dosandae-ro, Gangnam-gu, Seoul, Korea
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 AeroShield. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0">
            <a 
              href="https://readdy.ai/?origin=logo" 
              className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
              rel="nofollow"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
